/** @format */

import {
  Button,
  Checkbox,
  Column,
  ComboBox,
  Loading,
  Modal,
  Row,
  Select,
  SelectItem,
  TextInput,
} from "carbon-components-react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UIShell from "../../components/UIShell";
import UIShellPagination from "../../components/UIShellPagination";
import {
  ACCOUNT_TYPES_UP,
  ACCOUNT_TYPES,
  SORT_BY_TYPES_UP,
  SORT_BY_TYPES,
} from "../../utils/constants";
import {
  bulkDeleteAccount,
  fetchAllAccount,
  updateAccount,
} from "../../redux/actions/accountAction";
import { debounce, sortBy } from "lodash";
import { useCallback } from "react";

const SUBS_PRICE_OPTIONS = {
  price_1PaHa8KUKmGoCsDv1noqv51T: "Creative Month",
  price_1PaHbJKUKmGoCsDvXZyCUanL: "Creative 3 Months",
  price_1PaHc7KUKmGoCsDv93BosIOM: "Creative 6 Months",
  price_1PaHcMKUKmGoCsDvTLtfYDdT: "Creative 1 Year",
  price_1PaHdGKUKmGoCsDvpwo2kqeC: "Company Month",
  price_1PaHdVKUKmGoCsDvkfS94LsO: "Company 3 Months",
  price_1PaHdjKUKmGoCsDvCm6Im7Wd: "Company 6 Months",
  price_1PaHdxKUKmGoCsDvbNmc2ZhQ: "Company 1 Year",
  price_1PaHeRKUKmGoCsDvRlx1dWOm: "Featured Month",
  price_1PaHeiKUKmGoCsDvW34BKKgB: "Featured 3 Months",
  price_1PaHevKUKmGoCsDvWlHj2hvK: "Featured 6 Months",
  price_1PaHf8KUKmGoCsDvRJOFM6Ho: "Featured 1 Year",
};

const headers = [
  {
    key: "email",
    header: "Email",
  },
  {
    key: "firstName",
    header: "First Name",
  },
  {
    key: "lastName",
    header: "Last Name",
  },
  { key: "createdAt", header: "Created date" },
  {
    key: "isEmailConfirmed",
    header: "Email Confirmed",
  },
  {
    key: "accountType",
    header: "Account Type",
  },
  {
    key: "subscription",
    header: "Subscription",
  },
  {
    key: "projectsNumber",
    header: "# of Projects",
  },
  {
    key: "isFeatured",
    header: "Is Featured",
  },
  {
    key: "isActive",
    header: "Is Active",
  },
  {
    key: "isEmailNotification",
    header: "Job Notify",
  },
  {
    key: "profilePicture",
    header: "Profile Picture",
  },
];

const filterOpts = {
  accountType: [
    {
      id: ACCOUNT_TYPES_UP.CREATIVE,
      text: ACCOUNT_TYPES.CREATIVE,
    },

    {
      id: ACCOUNT_TYPES_UP.COMPANY,
      text: ACCOUNT_TYPES.COMPANY,
    },

    {
      id: ACCOUNT_TYPES_UP.ADMINISTRATOR,
      text: ACCOUNT_TYPES.ADMINISTRATOR,
    },
    {
      id: ACCOUNT_TYPES_UP.CONTENT_MANAGER,
      text: ACCOUNT_TYPES.CONTENT_MANAGER,
    },
  ],

  isFeatured: [
    {
      id: true,
      text: "Yes",
    },
    {
      id: false,
      text: "No",
    },
  ],
};

const sortOpts = [
  {
    id: SORT_BY_TYPES_UP.DATE,
    text: SORT_BY_TYPES.DATE,
  },
  {
    id: SORT_BY_TYPES_UP.NUMBER,
    text: SORT_BY_TYPES.NUMBER,
  },
];

function AccountPage({ dataTableList, isLoading }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isLoadingData, setIsLoadingData] = useState(true);

  const [paginationContent, setPaginationContent] = useState({
    query: "",
    page: 0,
    limit: 10,
    total: 0,
    totalItems: 0,
    rows: [],
    accountType: "",
    isFeatured: "",
    isActive: false,
    isEmailConfirmed: false,
    isEmailNotification: false,
  });

  const [modalContent, setModalContent] = useState({
    modalHeading: "",
    isOpen: false,
    accountId: "",
    firstName: "",
    lastName: "",
    email: "",
    accountType: "",
    isFeatured: false,
    isActive: false,
  });

  const [sortData, setSortData] = useState({
    sortBy: "",
    sortDirection: "",
  });

  const viewAccountDetail = (data) => {
    const accountId = data[0].id.split(":")[0];
    console.info(data);

    const {
      email,
      firstName,
      lastName,
      isEmailConfirmed,
      accountType,
      subscription,
      projectsNumber,
      isFeatured,
      isActive,
    } = Object.fromEntries(
      headers.map(({ key }) => [
        key,
        data.find((cell) => cell.info.header === key)?.value,
      ])
    );

    setModalContent((v) => ({
      isOpen: true,
      modalHeading: `${firstName} ${lastName}`,
      accountId,
      firstName,
      lastName,
      email,
      accountType,
      isFeatured: isFeatured === "Yes",
      isActive: isActive === "Yes",
      isEmailConfirmed,
    }));
  };

  const updateAccountDetail = async () => {
    dispatch(
      updateAccount(modalContent, () => {
        // reset modal content
        setModalContent({
          modalHeading: "",
          isOpen: false,
          accountId: "",
          firstName: "",
          lastName: "",
          email: "",
          accountType: "",
          isFeatured: false,
          isActive: false,
          isEmailConfirmed: false,
        });

        dispatch(
          fetchAllAccount(
            {
              query: paginationContent.query,
              page: 0,
              limit: paginationContent.limit,
            },
            ({ filteredData }) => {
              setPaginationContent((v) => ({
                ...v,
                rows: filteredData,
              }));
            },
          ),
        );
      }),
    );
  };

  const bulkDelete = async (_items) => {
    dispatch(
      bulkDeleteAccount(
        {
          accountIds: _items.map((v) => v.id),
        },
        () => {
          dispatch(
            fetchAllAccount(
              { query: "", page: 0, limit: paginationContent.limit },
              ({ totalFiltered, total, filteredData }) =>
                setPaginationContent((v) => ({
                  ...v,
                  rows: filteredData,
                  skip: totalFiltered,
                  total,
                  totalItems: getTotalItems(total, paginationContent.limit),
                  page: 0,
                  query: "",
                })),
            ),
          );
        },
      ),
    );
  };

  const paginationChange = async (_newPage) => {
    fetch({
      query: paginationContent.query,
      page: _newPage,
      limit: paginationContent.limit,
      accountType: paginationContent.accountType,
      isFeatured: paginationContent.isFeatured,
    });
  };

  const searchTable = debounce(async (e) => {
    const { value } = e.target;

    await fetch({
      query: value,
      page: 0,
      limit: paginationContent.limit,
      accountType: paginationContent.accountType,
      isFeatured: paginationContent.isFeatured,
    });
  }, 300);

  const applyFilters = async (_filters) => {
    const { accountType, isFeatured } = _filters;
    setPaginationContent((_state) => ({
      ..._state,
      accountType,
      isFeatured,
    }));

    fetch({
      query: paginationContent.query,
      page: 0,
      limit: paginationContent.limit,
      accountType,
      isFeatured,
    });
  };

  useEffect(() => {
    fetch({
      query: paginationContent.query,
      page: 0,
      limit: paginationContent.limit,
      accountType: paginationContent.accountType,
      isFeatured: paginationContent.isFeatured,
      orderBy: sortData.sortBy,
      orderDirection: sortData.sortDirection,
    });
  }, [sortData]);

  const applySort = useCallback((sortBy, sortDirection) => {
    setSortData({ sortBy, sortDirection });
  }, []);

  const getTotalItems = (_total, _limit) => Math.ceil(_total / _limit);

  const fetch = ({
    query,
    page,
    limit,
    accountType,
    isFeatured,
    orderBy,
    orderDirection,
  }) => {
    setIsLoadingData(true);

    dispatch(
      fetchAllAccount(
        {
          query,
          page,
          limit,
          accountType,
          isFeatured,
          orderBy,
          orderDirection,
        },
        ({ filteredData, priceIds, totalFiltered, total }) => {
          const updatedData = filteredData.map((item) => {
            const accountId = item._id;
            const price = priceIds.find((price) => price._id === accountId);
            const subscription =
              SUBS_PRICE_OPTIONS?.[price?.priceId] || "Wrong sub data";

            return {
              ...item,
              subscription: subscription,
            };
          });
          setPaginationContent((v) => ({
            skip: totalFiltered,
            priceIds: priceIds,
            page,
            query,
            limit,
            total,
            totalItems: getTotalItems(total, limit),
            rows: updatedData,
            accountType,
            isFeatured,
          }));
          setIsLoadingData(false);
        },
      ),
    );
  };

  // useEffect(() => {
  //   fetch(paginationContent);
  // }, [
  //   paginationContent.page,
  //   paginationContent.limit,
  //   // paginationContent.query,
  //   paginationContent.accountType,
  //   paginationContent.isFeatured,
  // ]);

  // console.log(paginationContent);

  return (
    <UIShell breadcrumbs={[{ name: "Home", link: "/" }, { name: "Account" }]}>
      {isLoadingData && <Loading />}
      <UIShellPagination
        dataTableList={paginationContent.rows}
        headers={headers}
        searchTable={searchTable}
        bulkDelete={bulkDelete}
        createForm={() => history.push("/accounts/form")}
        viewDetail={viewAccountDetail}
        paginationChange={paginationChange}
        totalItems={paginationContent.totalItems}
        page={paginationContent.page}
        filterComp={<FilterComp onFilter={applyFilters} />}
        onSort={applySort}
      />

      <Modal
        modalHeading={modalContent.modalHeading}
        modalLabel="Account details"
        primaryButtonText="Update"
        primaryButtonDisabled={isLoading}
        secondaryButtonText="Cancel"
        open={modalContent.isOpen}
        onRequestSubmit={() => updateAccountDetail()}
        onRequestClose={() => setModalContent((v) => ({ ...v, isOpen: false }))}
      >
        <p style={{ marginBottom: "1rem" }}>
          Custom domains direct requests for your apps in this Cloud Foundry
          organization to a URL that you own. A custom domain can be a shared
          domain, a shared subdomain, or a shared domain and host.
        </p>

        <TextInput
          data-modal-primary-focus
          labelText="First Name"
          placeholder="First Name"
          value={modalContent.firstName}
          onChange={(_v) =>
            setModalContent((v) => ({ ...v, firstName: _v.target.value }))
          }
          style={{ marginBottom: "1rem" }}
        />
        <TextInput
          data-modal-primary-focus
          labelText="Last Name"
          placeholder="Last Name"
          value={modalContent.lastName}
          onChange={(_v) =>
            setModalContent((v) => ({ ...v, lastName: _v.target.value }))
          }
          style={{ marginBottom: "1rem" }}
        />
        <TextInput
          data-modal-primary-focus
          labelText="Email"
          placeholder="Email"
          value={modalContent.email}
          onChange={(_v) =>
            setModalContent((v) => ({ ...v, email: _v.target.value }))
          }
          // readOnly={true}
          style={{ marginBottom: "1rem" }}
        />
        <Select
          onChange={(_v) =>
            setModalContent((v) => ({ ...v, accountType: _v.target.value }))
          }
          id="select-1"
          defaultValue={modalContent.accountType}
          labelText="Account Type"
          style={{ marginBottom: "1rem" }}
        >
          <SelectItem
            selected={modalContent.accountType === ACCOUNT_TYPES_UP.COMPANY}
            value={ACCOUNT_TYPES_UP.COMPANY}
            text={ACCOUNT_TYPES.COMPANY}
          />
          <SelectItem
            selected={modalContent.accountType === ACCOUNT_TYPES_UP.CREATIVE}
            value={ACCOUNT_TYPES_UP.CREATIVE}
            text={ACCOUNT_TYPES.CREATIVE}
          />
          <SelectItem
            selected={
              modalContent.accountType === ACCOUNT_TYPES_UP.ADMINISTRATOR
            }
            value={ACCOUNT_TYPES_UP.ADMINISTRATOR}
            text={ACCOUNT_TYPES.ADMINISTRATOR}
          />
        </Select>

        <Select
          onChange={(_v) =>
            setModalContent((v) => ({
              ...v,
              isFeatured: _v.target.value === "true",
            }))
          }
          disabled={modalContent.accountType !== ACCOUNT_TYPES_UP.CREATIVE}
          id="select-2"
          defaultValue={modalContent.isFeatured}
          labelText="Is Featured"
          style={{ marginBottom: "1rem" }}
        >
          <SelectItem
            selected={modalContent.isFeatured}
            value={true}
            text="Yes"
          />
          <SelectItem
            selected={!modalContent.isFeatured}
            value={false}
            text="No"
          />
        </Select>

        <Select
          onChange={(_v) =>
            setModalContent((v) => ({
              ...v,
              isActive: _v.target.value === "true",
            }))
          }
          id="select-3"
          defaultValue={modalContent.isActive}
          labelText="Is Active"
          style={{ marginBottom: "1rem" }}
        >
          <SelectItem
            selected={modalContent.isActive}
            value={true}
            text="Yes"
          />
          <SelectItem
            selected={!modalContent.isActive}
            value={false}
            text="No"
          />
        </Select>
      </Modal>
    </UIShell>
  );
}

const FilterComp = ({ onFilter }) => {
  const [filterValues, setFilterValues] = useState({
    accountType: undefined,
    isFeatured: undefined,
  });

  return (
    <>
      <Row style={{ marginBottom: 10 }}>
        <Column>
          <ComboBox
            titleText="Account Type"
            items={filterOpts.accountType}
            itemToString={(item) => (item ? item.text : "")}
            onChange={({ selectedItem }) =>
              setFilterValues((_state) => ({
                ..._state,
                accountType: selectedItem ? selectedItem.id : undefined,
              }))
            }
          />
        </Column>

        <Column>
          <ComboBox
            titleText="Is Featured"
            items={filterOpts.isFeatured}
            itemToString={(item) => (item ? item.text : "")}
            onChange={({ selectedItem }) =>
              setFilterValues((_state) => ({
                ..._state,
                isFeatured: selectedItem ? selectedItem.id : undefined,
              }))
            }
          />
        </Column>
      </Row>

      <Row style={{ marginBottom: 20 }}>
        <Column>
          <Button onClick={() => onFilter(filterValues)}>Apply Filter</Button>
        </Column>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    dataTableList: state.accountReducer.dataTableList,
    isLoading: state.uxReducer.isLoading,
  };
};

export default connect(mapStateToProps)(AccountPage);
